import { render, staticRenderFns } from "./unit-info-edit.html?vue&type=template&id=64481c74&scoped=true&"
import script from "./unit-info-edit.js?vue&type=script&lang=js&"
export * from "./unit-info-edit.js?vue&type=script&lang=js&"
import style0 from "./unit-info-edit.scss?vue&type=style&index=0&id=64481c74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64481c74",
  null
  
)

export default component.exports